import { supabase } from '../lib/supabaseClient';

export const isAuthenticated = async () => {
  const { data } = await supabase.auth.getSession();
  return Boolean(data.session);
};

export const signOut = async () => {
  await supabase.auth.signOut();
  window.dispatchEvent(new Event('authchange'));
};

export const emitAuthChange = () => {
  window.dispatchEvent(new Event('authchange'));
};
